import React, { Component } from 'react'
import { connect } from 'react-redux';


import { exibirEvidencia } from '../../actions'

class ModalEvidencia extends Component {
    constructor(props){
        super(props)
    }

    componentDidMount(){
        
    }
    
    render(){
        const  { exibir_doc_load, evidencia } = this.props.documentos

        //var fileURL = `data:application/pdf;base64,${evidencia}`//undefined

        return(
            <div className="modal fade" id="modalEvidence" tabIndex="-1" role="dialog" aria-labelledby="exampleModalLabel"
                aria-hidden="true">
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="exampleModalLabel">Evidências</h5>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
        
                        <div className="modal-body text-center">
        
                            {exibir_doc_load
                                
                                ?<div className="spinner-border" role="status"></div>
                                
                                : evidencia && evidencia.length > 0
                                    ? evidencia.map( (e, index) => {
                                        const { base64file, categoria } = e
                                        const fileURL = `data:image/png;base64,${base64file}`//undefined
                                        return (
                                            <div className="card mt-3" key={'evidencia'+index}>
                                                <div style={{width: '100%'}}>          
                                                    <img src={fileURL} className="card-img-top" alt={categoria} />                                                    
                                                </div>

                                                <div className="card-body">
                                                    <h5>{categoria}</h5>
                                                    {/* <small className="text-muted">13/06/2019 - 13:36</small> */}
                                                </div>
                                            </div>
                                        )
                                    })
                                    :<p>Nenhum arquivo encontrado.</p>
                            }
                        </div>
        
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" data-dismiss="modal">Fechar</button>       
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = ({ documentos }) => {
    return {
        documentos
    }
}

export default connect(mapStateToProps, {
    exibirEvidencia
})(ModalEvidencia);

const customStyles = {
    main: {
        paddingLeft: '2%',
        paddingRight: '2%'
    },
    modal:{
        width:'50%',
        left:'35%',
        top: '80px',
    },
    container: {
        width:'100%',
        height:'100%',
    }
}